module.exports = __webpack_public_path__ + "static/media/21b.3944bbc2.jpg";